<template>
	<div v-if="List && List.length" class="w5-vds-plan-list-filter-wrapper plan">
		<div class="w5-vds-plan-list-block">
			<div v-for="item in List"
				class="w5-vds-plan-list-item outer-disks"
				:key="item.id"
				:class="{ 'selected': item.id == curValue.id }"
				@click.prevent.stop="onClick(item)">
				<div class="w5-vds-plan-list-item-up">
					<img :src="item.img" class="local-group disks" :class="{ 'selected': item.id == curValue.id, 'macloud': AppName === 'macloud' }" />
				</div>
				<div class="w5-vds-plan-list-item-down">
					<strong>{{ item.name }}</strong>
				</div>
			</div>
		</div>
		<div class="description"><p v-withSafeTags="localeFtc(Description)"></p></div>
	</div>	
</template>
<script>
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'outerDiskType',
	//=========================================================================
	// свойства
	//=========================================================================
	props: ['value'],
	//=========================================================================
	// данные
	//=========================================================================
	data() {
		return {
			List: [
				{
					id: 17,
					name: 'NVMe',
					description: 'service/extdisk_nvme_description',
					img: '/static/img/nvme.svg'
				},
				{
					id: 16,
					name: 'HDD',
					description: 'service/extdisk_hdd_description',
					img: '/static/img/hdd.svg'
				}
			],
			curValue: null
		}
	},
	//=========================================================================
	// методы
	//=========================================================================
	computed: {
		Description() {
			return this.curValue ? this.curValue.description : ''
		}
	},
	//=========================================================================
	// создание
	//=========================================================================
	created() {
		this.initValue(this.value)
	},
	//=========================================================================
	// методы
	//=========================================================================
	methods: {
		initValue(value) {
			if (this.curValue &&
				'id' in this.curValue &&
				String(this.curValue.id) === String(value)) {
				return
			}

			this.curValue = null
			this.List.some(i => {
				if (String(i.id) === String(value)) {
					this.curValue = i
					return true
				}
			})
		},
		onClick(item) {
			this.curValue = item
			this.$emit('focus')
			this.$emit('input', item.id)
		}
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		value(newValue) {
			this.initValue(newValue)
		}
	}
	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
</style>



// WEBPACK FOOTER //
// outerdisktype.vue?4a77bb18